/**
 * Copyright (c) 2023 Google LLC
 * SPDX-License-Identifier: MIT
 */

export * from './available_locales';
export * from './i18n_resources';
export * from './resources/cs-CZ';
export * from './resources/da-DK';
export * from './resources/de-DE';
export * from './resources/en';
export * from './resources/es-ES';
export * from './resources/fi-FI';
export * from './resources/fr-CA';
export * from './resources/fr-FR';
export * from './resources/he-IL';
export * from './resources/hi-IN';
export * from './resources/it-IT';
export * from './resources/ja-JP';
export * from './resources/ko-KR';
export * from './resources/lt-LT';
export * from './resources/nb-NO';
export * from './resources/nl-NL';
export * from './resources/pl-PL';
export * from './resources/pt-BR';
export * from './resources/pt-PT';
export * from './resources/ru-RU';
export * from './resources/sv-SE';
export * from './resources/th-TH';
export * from './resources/tr-TR';
export * from './resources/uk-UA';
export * from './resources/zh-CN';
export * from './resources/zh-TW';
